import { useContext, useEffect, useState } from 'react';
import { appContext, AppContext } from '../../../context/AppContext';
import { MerchantOrder, SubscriptionUsage } from '@anticatrade/shared';
import { MerchantOrdersResponse, SubscriptionUsageResponse } from '@anticatrade/admin';

const useBilling = () => {
	const [subscriptionUsage, setSubscriptionUsage] = useState<SubscriptionUsage>();
	const [merchantOrders, setMerchantOrders] = useState<MerchantOrder[]>();
	const [count, setCount] = useState<number>();
	const [isLoading, setIsLoading] = useState<boolean>(true);

	const { api, handleError } = useContext(appContext as React.Context<AppContext>);

	// @ts-ignore
	const showInvoice = async (id: number) => {};

	useEffect(() => {
		const fetchData = async () => {
			setIsLoading(true);
			let subscriptionUsageRes: SubscriptionUsageResponse;
			try {
				subscriptionUsageRes = await api.subscriptionUsage();
			} catch (err) {
				handleError(err as Error);
				setIsLoading(false);
				return;
			}
			let res: MerchantOrdersResponse;
			try {
				res = await api.merchantOrders();
			} catch (err) {
				handleError(err as Error);
				setIsLoading(false);
				return;
			}
			setSubscriptionUsage(subscriptionUsageRes.subscriptionUsage);
			setMerchantOrders(res.merchantOrders);
			setCount(res.count);
			setIsLoading(false);
		};
		fetchData();
	}, []);

	return {
		isLoading,
		subscriptionUsage,
		merchantOrders,
		count,
		showInvoice,
	};
};

export { useBilling };
